/**
 * This type contains helper methods to handle parsing.
 */
export class ParsingHelper {

	/**
	 * Parse size to px
	 * @param size
	 * @param rootFontSize
	 * @param referencePx
	 */
	public static parseSizeToPx(size: string, rootFontSize = 16, referencePx = 1000): number|null {
		if (!size) return null;
		const s = String(size).trim();
		if (s.endsWith('px')) return parseFloat(s);
		if (s.endsWith('rem')) return parseFloat(s) * rootFontSize;
		if (s.endsWith('%')) return (parseFloat(s) / 100) * referencePx;
		const num = parseFloat(s);
		return Number.isFinite(num) ? num : null;
	}

}
